
//------------------------------------------------------------------------------
// <auto-generated>
//     This code was generated from a template (Model.tst).
//
//     Manual changes to this file may cause unexpected behavior in your application.
//     Manual changes to this file will be overwritten if the code is regenerated.
// </auto-generated>
//------------------------------------------------------------------------------

import { OrderModel } from './Entities.GormCrm.Order';
import { PlanReplacementNewPlanModel } from './Entities.GormCrm.PlanReplacementNewPlan';
import { PlanReplacementOldPlanModel } from './Entities.GormCrm.PlanReplacementOldPlan';
import { Model, ModelProperty } from 'models/Model';


export class PlanReplacementModel extends Model<PlanReplacementModel> {
	public static classProperties: ModelProperty[] = [
		
		{ name: 'id', type: 'string', isHidden: true },
		{ name: 'orderId', type: 'string' },
		{ name: 'created', type: 'Date', isHidden: true },
		{ name: 'delivered', type: 'Date' },
		{ name: 'order', type: 'OrderModel', isHidden: true, isObject: true, new: () => { return new OrderModel }, properties: () => { return OrderModel.classProperties } },
		{ name: 'planReplacementNewPlans', type: 'PlanReplacementNewPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new PlanReplacementNewPlanModel }, properties: () => { return PlanReplacementNewPlanModel.classProperties } },
		{ name: 'planReplacementOldPlans', type: 'PlanReplacementOldPlanModel[]', isHidden: true, isArray: true, isObject: true, new: () => { return new PlanReplacementOldPlanModel }, properties: () => { return PlanReplacementOldPlanModel.classProperties } }
	];
	[key: string]: any;
	
	public id?: string;
	public orderId?: string;
	public created?: Date;
	public delivered?: Date;
	public order?: OrderModel;
	public planReplacementNewPlans: PlanReplacementNewPlanModel[];
	public planReplacementOldPlans: PlanReplacementOldPlanModel[];
    
	constructor(){
		super();
		this.id = undefined;
		this.orderId = undefined;
		this.created = undefined;
		this.delivered = undefined;
		this.order = undefined;
		this.planReplacementNewPlans = [];
		this.planReplacementOldPlans = [];
		
	}
	getProperties(){
		return PlanReplacementModel.classProperties;
	}
}

